<!-- treeLoading keeps the panel mounted on first open, when there are no facets and no tree to measure it by yet. -->
<div class="p-3 filter-panel h-100 scrollable" *ngIf="loading || treeLoading || !isEmpty">
	<!-- Placeholders while the new tab's facets arrive, so the panel keeps its width instead of collapsing. -->
	<ng-container *ngIf="isLoadingEmpty">
		<div *ngFor="let group of [1, 2, 3]" class="mb-4">
			<div class="skeleton skeleton-heading mb-2"></div>
			<div *ngFor="let row of [1, 2, 3]" class="skeleton skeleton-row mb-2"></div>
		</div>
	</ng-container>

	<!-- The tree is counted per tab, so it reloads on its own while the facets beside it stay put. -->
	<div *ngIf="treeLoading && !isLoadingEmpty" class="mb-4">
		<div class="skeleton skeleton-heading mb-2"></div>
		<div *ngFor="let row of [1, 2, 3, 4, 5]" class="skeleton skeleton-row mb-2"></div>
	</div>

	<div *ngIf="segments?.length && !isLoadingEmpty && !treeLoading" class="mb-4">
		<app-category-tree [segments]="segments" [totalCategories]="totalCategories" [scope]="scope" (scopeChanged)="scopeChanged.emit($event)"></app-category-tree>
	</div>

	<div *ngFor="let section of visibleSections" class="mb-4">
		<div class="d-flex flex-row align-items-center" [ngClass]="section.hasSearch ? 'mb-3' : 'mb-2'">
			<h4 class="mb-0 mr-1 selectable d-flex align-items-center" [ngClass]="{ 'flex-weight-1': !section.hasSearch }" (click)="toggleCollapsed(section)">
				<i class="wq text-secondary mr-1" [ngClass]="sectionState(section).isCollapsed ? 'wq-caret-right' : 'wq-caret-down'"></i>{{ section.name }}
			</h4>
			<div class="input-group flex-weight-1" *ngIf="section.hasSearch && !sectionState(section).isCollapsed">
				<input class="form-control rounded-pill text-uppercase text-tiny" type="text" placeholder="Search..." (input)="onSectionSearch(section, $event)">
			</div>
		</div>

		<ng-container *ngIf="!sectionState(section).isCollapsed">
			<div class="filter-values" [class.expanded]="sectionState(section).isExpanded" [style.max-height]="sectionState(section).isExpanded ? section.expandedMaxHeight : null">
				<div *ngFor="let value of shownValues(section); trackBy: valueKey">
					<!-- A group: one checkbox over its children, which fold away under the caret. -->
					<ng-container *ngIf="isGroup(value); else plainValue">
						<div class="d-flex align-items-center mb-2 mr-3">
							<label class="custom-control custom-checkbox m-0 d-flex align-items-center flex-weight-1" style="min-width: 0;">
								<input type="checkbox" class="custom-control-input" [checked]="isSelected(section, value)" [indeterminate]="isPartial(section, value)" (change)="toggle(section, value)">
								<span class="custom-control-label text-uppercase text-tiny text-bold flex-weight-1 d-flex align-items-center" [ngClass]="value.count === 0 ? 'text-secondary' : 'text-dark'">
									<span class="text-truncate" [title]="value.label">{{ value.label }}</span>
								</span>
								<span class="text-secondary text-tiny ml-2" *ngIf="value.count !== undefined && value.count !== null">{{ value.count }}</span>
							</label>
							<i class="wq text-secondary selectable ml-2" [ngClass]="isGroupOpen(section, value) ? 'wq-caret-down' : 'wq-caret-right'" (click)="toggleGroup(section, value)"></i>
						</div>

						<div *ngIf="isGroupOpen(section, value)" class="filter-group-children ml-2 pl-3 mb-2 border-left">
							<label *ngFor="let child of children(section, value)" class="custom-control custom-checkbox m-0 mb-2 mr-3 d-flex align-items-center">
								<input type="checkbox" class="custom-control-input" [checked]="isSelected(section, child)" (change)="toggle(section, child)">
								<span class="custom-control-label text-uppercase text-tiny flex-weight-1 d-flex align-items-center" [ngClass]="child.count === 0 ? 'text-secondary' : 'text-dark'">
									<span class="text-truncate" [title]="child.label">{{ child.label }}</span>
								</span>
								<span class="text-secondary text-tiny ml-2" *ngIf="child.count !== undefined && child.count !== null">{{ child.count }}</span>
							</label>
						</div>
					</ng-container>

					<ng-template #plainValue>
						<label class="custom-control custom-checkbox m-0 mb-2 mr-3 d-flex align-items-center">
							<input type="checkbox" class="custom-control-input" [checked]="isSelected(section, value)" (change)="toggle(section, value)">
							<!-- text-truncate has to sit on an inner span: on the label itself its overflow:hidden clips the checkbox indicator. -->
							<span class="custom-control-label text-uppercase text-tiny flex-weight-1 d-flex align-items-center" [ngClass]="value.count === 0 ? 'text-secondary' : 'text-dark'">
								<span *ngIf="value.color" class="label-dot rounded-circle mr-1" [style.background]="value.color"></span>
								<span class="text-truncate" [title]="value.label">{{ value.label }}</span>
							</span>
							<span class="text-secondary text-tiny ml-2" *ngIf="value.count !== undefined && value.count !== null">{{ value.count }}</span>
						</label>
					</ng-template>
				</div>
			</div>

			<div class="text-secondary text-tiny mb-2" *ngIf="undrawnCount(section) > 0">
				{{ undrawnCount(section) }} more &mdash; search to find them.
			</div>

			<div class="selectable text-primary text-uppercase text-tiny" *ngIf="isExpandable(section)" (click)="toggleExpanded(section)">
				{{ sectionState(section).isExpanded ? 'Collapse all' : 'Expand all' }}
			</div>
		</ng-container>
	</div>
</div>
